import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { projectsService } from '../api/projects.service';
import { PROJECT_KEYS } from './queryKeys';
import type { CreateProjectPayload } from '../types';

export function useCreateProject() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);
  const { toast } = useToast();
  const { t } = useTranslation('projects');

  return useMutation({
    mutationFn: (payload: CreateProjectPayload) => projectsService.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PROJECT_KEYS.byOrg(orgId ?? '') });
      toast.success({ title: t('toast.created') });
    },
  });
}
